import {FormControl} from 'platform/components';
import {VStack, Text, HStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, useDebouncedValue} from 'shared/web';

import {DelayEnum} from '../constants/DelayEnum';
import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {calculateTotalPrices} from '../utils/calculateTotalPrices';

interface TotalPriceProps {
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  hasMoreThanOnePage: boolean;
}

export function TotalPrice(props: TotalPriceProps) {
  const [currency, listOfItems] = useWatch({
    control: props.control,
    name: ['basicInformation.currency', 'listOfItems'],
  });

  const debouncedListOfItems = useDebouncedValue(listOfItems, DelayEnum.TOTAL_PRICE);

  const calculatedTotalPrice = calculateTotalPrices(debouncedListOfItems);

  const formatCurrency = useFormatCurrency();

  return (
    <VStack align={props.hasMoreThanOnePage ? 'flex-start' : 'flex-end'} spacing={1}>
      <Text size="xSmall" color="secondary">
        {i18n.t('entity.warehouse.labels.totalPrice')}
      </Text>
      <HStack spacing={2}>
        <Text alternative>
          {formatCurrency(calculatedTotalPrice.withVat ?? EMPTY_PLACEHOLDER, currency, 2)}
        </Text>
        <Text color="tertiary">{`${formatCurrency(calculatedTotalPrice.withoutVat ?? EMPTY_PLACEHOLDER, currency, 2)} ${i18n.t('general.labels.w/oVat')}`}</Text>
      </HStack>
    </VStack>
  );
}
